import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana47Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg
      width={style?.width || "1219"}
      height={style?.height || "941"}
      viewBox="0 0 1221 921"
      fill="none"
    >
      <rect width="1221" height="921" fill="url(#pattern0_1466_29440)" />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("12"))}
        d="M296.773 407.347L368.21 381.551L386.067 393.457L340.427 468.862L290.82 437.113C281.295 422.825 290.82 411.316 296.773 407.347Z"
        fill={getFillByLot(12, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("11"))}
        d="M388.046 498.625L340.422 468.86L386.062 393.454L433.687 423.219L388.046 498.625Z"
        fill={getFillByLot(11, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("10"))}
        d="M435.675 528.39L388.051 498.624L433.691 423.219L481.315 451L435.675 528.39Z"
        fill={getFillByLot(10, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("9"))}
        d="M483.292 554.186L435.668 528.39L481.308 451L526.948 478.781L483.292 554.186Z"
        fill={getFillByLot(9, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("8"))}
        d="M528.937 581.97L483.297 554.189L526.953 478.783L574.577 506.564L528.937 581.97Z"
        fill={getFillByLot(8, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("7"))}
        d="M578.556 607.764L528.947 581.967L574.587 506.562L622.212 534.342L578.556 607.764Z"
        fill={getFillByLot(7, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("6"))}
        d="M608.312 623.64L578.547 607.765L622.203 534.344L681.733 572.046C671.15 585.275 647.206 613.718 636.093 621.655C624.981 629.593 612.942 626.285 608.312 623.64Z"
        fill={getFillByLot(6, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("5"))}
        d="M723.415 524.421L681.744 572.046L624.197 536.327L663.884 472.828C677.775 480.766 707.937 498.228 717.462 504.578C726.987 510.928 725.399 520.453 723.415 524.421Z"
        fill={getFillByLot(5, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("4"))}
        d="M606.322 439.099L663.868 472.833L624.181 536.332L566.635 502.598L606.322 439.099Z"
        fill={getFillByLot(4, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("3"))}
        d="M548.789 405.36L606.335 439.094L566.648 502.594L509.102 468.86L548.789 405.36Z"
        fill={getFillByLot(3, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot("2"))}
        d="M491.242 369.642L548.788 405.36L509.101 466.875L451.555 433.141L491.242 369.642Z"
        fill={getFillByLot(2, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <path
        className="cursor-pointer"
        onClick={(e) => landSelector(e, findLandByLot(""))}
        d="M459.495 349.799L491.245 369.642L451.558 433.142L368.215 381.548L459.495 349.799Z"
        fill={getFillByLot(1, selected, lands)}
        fill-opacity="0.64"
        stroke="#6D6859"
        stroke-opacity="0.6"
      />
      <defs>
        <pattern
          id="pattern0_1466_29440"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0_1466_29440"
            transform="matrix(0.00272187 0 0 0.00360847 -3.25761 -2.31636)"
          />
        </pattern>
        <image
          id="image0_1466_29440"
          width="4096"
          height="2304"
          href="/mz2.png"
        />
      </defs>
    </svg>
  );
};
